module.exports = __webpack_public_path__ + "img/communitysupply.0e21dfbd.jpg";